/* Serelia Mum — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  /* ---------- Animaciones de entrada ---------- */
  var revealObserver = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.sr-reveal:not(.sr-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('sr-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sr-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Guía de tallas: cm / pulgadas ---------- */
  function initSizeToggles(root) {
    (root || document).querySelectorAll('[data-sr-sizes]').forEach(function (wrap) {
      if (wrap.dataset.srReady) return;
      wrap.dataset.srReady = '1';
      wrap.querySelectorAll('[data-sr-unit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.getAttribute('data-sr-unit');
          wrap.classList.toggle('sr-sizes--in', unit === 'in');
          wrap.querySelectorAll('[data-sr-unit]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---------- Ventana lateral (guía de tallas en producto) ---------- */
  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-sr-open]');
      if (opener) {
        var m = document.getElementById(opener.getAttribute('data-sr-open'));
        if (m) { e.preventDefault(); m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
        return;
      }
      if (e.target.closest('[data-sr-close]')) {
        var modal = e.target.closest('.sr-modal');
        if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.sr-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
      document.body.style.overflow = '';
    });
  }

  /* ---------- Página de producto ---------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return value;
    });
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-sr-product]').forEach(function (wrap) {
      if (wrap.dataset.srReady) return;
      wrap.dataset.srReady = '1';

      var dataEl = wrap.querySelector('[data-sr-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var moneyFormat = wrap.getAttribute('data-money-format');
      var form = wrap.querySelector('[data-sr-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var addBtn = wrap.querySelector('[data-sr-add]');
      var addLabel = addBtn ? addBtn.querySelector('[data-sr-add-label]') : null;
      var priceNow = wrap.querySelectorAll('[data-sr-price]');
      var priceWas = wrap.querySelector('[data-sr-compare]');
      var saveBadge = wrap.querySelector('[data-sr-save]');
      var errorEl = wrap.querySelector('[data-sr-error]');
      var txtAdd = wrap.getAttribute('data-txt-add');
      var txtSold = wrap.getAttribute('data-txt-sold');
      var txtUnavailable = wrap.getAttribute('data-txt-unavailable');
      var txtAdding = wrap.getAttribute('data-txt-adding');

      /* Galería */
      var mainImg = wrap.querySelector('[data-sr-main-img]');
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-sr-thumb]'));
      var current = 0;
      function showMedia(i) {
        if (!mainImg || !thumbs.length) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = t.getAttribute('data-src');
          mainImg.srcset = t.getAttribute('data-srcset') || '';
          mainImg.alt = t.getAttribute('data-alt') || '';
          mainImg.classList.remove('is-fading');
        }, 180);
        thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === current); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showMedia(i); }); });
      var prev = wrap.querySelector('[data-sr-prev]');
      var next = wrap.querySelector('[data-sr-next]');
      if (prev) prev.addEventListener('click', function () { showMedia(current - 1); });
      if (next) next.addEventListener('click', function () { showMedia(current + 1); });
      function showMediaById(mediaId) {
        if (!mediaId) return;
        thumbs.forEach(function (t, i) { if (t.getAttribute('data-media-id') == mediaId) showMedia(i); });
      }

      /* Variantes */
      function selectedOptions() {
        return Array.prototype.map.call(wrap.querySelectorAll('[data-sr-option]'), function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function findVariant() {
        var opts = selectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
        });
      }
      function updateAvailability() {
        var fieldsets = wrap.querySelectorAll('[data-sr-option]');
        var opts = selectedOptions();
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (input) {
            var test = opts.slice(); test[idx] = input.value;
            var exists = variants.some(function (v) {
              return v.available && v.options.every(function (o, i) { return test[i] === o; });
            });
            var pill = input.nextElementSibling;
            if (pill) pill.classList.toggle('is-unavailable', !exists);
          });
        });
      }
      function setButton(variant) {
        if (!addBtn) return;
        if (!variant) { addBtn.disabled = true; if (addLabel) addLabel.textContent = txtUnavailable; return; }
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? txtAdd : txtSold;
      }
      function onChange() {
        var v = findVariant();
        wrap.querySelectorAll('[data-sr-option]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          var out = fs.querySelector('[data-sr-option-value]');
          if (out && checked) out.textContent = checked.value;
        });
        updateAvailability();
        setButton(v);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (p) { p.textContent = money(v.price, moneyFormat); });
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.textContent = onSale ? money(v.compare_at_price, moneyFormat) : ''; priceWas.hidden = !onSale; }
        if (saveBadge) {
          saveBadge.hidden = !onSale;
          if (onSale) saveBadge.textContent = saveBadge.getAttribute('data-label').replace('[%]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
        }
        if (v.featured_media) showMediaById(v.featured_media.id);
        if (window.history && window.history.replaceState && !window.Shopify.designMode) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      wrap.querySelectorAll('[data-sr-option] input').forEach(function (input) { input.addEventListener('change', onChange); });
      if (variants.length) updateAvailability();

      /* Cantidad */
      var qty = wrap.querySelector('[data-sr-qty]');
      if (qty) {
        wrap.querySelectorAll('[data-sr-qty-btn]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(qty.value, 10) || 1;
            n += parseInt(b.getAttribute('data-sr-qty-btn'), 10);
            qty.value = Math.max(1, n);
          });
        });
      }

      /* Añadir al carrito (abre el carrito lateral de Dawn) */
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') return; // envío normal → /cart
          e.preventDefault();
          if (errorEl) errorEl.classList.remove('is-visible');
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = txtAdding;
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: idInput.value,
              quantity: qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.classList.add('is-visible'); }
                return;
              }
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            })
            .catch(function () { form.submit(); })
            .finally(function () { setButton(findVariant() || variants[0]); });
        });
      }

      /* Barra fija en móvil */
      var sticky = wrap.querySelector('[data-sr-sticky]');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var past = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', past);
          });
        }).observe(addBtn);
        var stickyBtn = sticky.querySelector('button');
        if (stickyBtn) stickyBtn.addEventListener('click', function () { addBtn.click(); });
      }
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-sr-compare]').forEach(function (frame) {
      if (frame.dataset.srReady) return;
      frame.dataset.srReady = '1';
      var range = frame.querySelector('.sr-compare__range');
      if (!range) return;
      var set = function () { frame.style.setProperty('--sr-pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Oferta con cuenta atrás (fecha real de fin) ---------- */
  function initOffers(root) {
    (root || document).querySelectorAll('[data-sr-offer]').forEach(function (box) {
      if (box.dataset.srReady) return;
      box.dataset.srReady = '1';
      var end = Date.parse(box.getAttribute('data-end'));
      if (isNaN(end)) { box.hidden = true; return; }
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var d = box.querySelector('[data-sr-d]'), h = box.querySelector('[data-sr-h]'),
          m = box.querySelector('[data-sr-m]'), s = box.querySelector('[data-sr-s]');
      var tick = function () {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { box.hidden = true; clearInterval(timer); return; }
        d.textContent = Math.floor(left / 86400);
        h.textContent = pad(Math.floor(left % 86400 / 3600));
        m.textContent = pad(Math.floor(left % 3600 / 60));
        s.textContent = pad(left % 60);
      };
      var timer = setInterval(tick, 1000);
      tick();

      var btn = box.querySelector('[data-sr-offer-add]');
      var wrap = box.closest('[data-sr-product]');
      if (btn && wrap) {
        btn.addEventListener('click', function () {
          var qty = wrap.querySelector('[data-sr-qty]');
          var add = wrap.querySelector('[data-sr-add]');
          if (qty) qty.value = btn.getAttribute('data-sr-offer-add');
          if (add && !add.disabled) add.click();
        });
      }
    });
  }

  function initAll(root) {
    initOffers(root);
    initCompare(root);
    initReveals(root);
    initSizeToggles(root);
    initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initModals();
    initAll(document);
  });

  /* Editor de Shopify: re-iniciar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
